import type { TagGetDto } from "@t/Common/Dtos/Tags/TagGetDto";
import type { Company } from "@t/Company";
import type { JobSpecialty } from "@t/JobSpecialty";
import type { LeadSource } from "@t/LeadSource";
import type { LeadType } from "@t/LeadType";
import type { Office } from "@t/Office";
import type { SelectOptionDto } from "@t/SelectOptionDto";
import type { Team } from "@t/Team";
import type { UserSelectOption } from "@t/UserSelectOption";
import { createContext, useContext } from "react";

export type CompanyContextType = {
    company: Company | undefined;
    users: UserSelectOption[] | undefined;
    usersOptionsWithLeads?: SelectOptionDto[] | undefined;
    activeUserOptions?: SelectOptionDto[] | undefined;
    allUserOptions?: SelectOptionDto[] | undefined;
    allOffices?: Office[] | undefined;
    allLeadSources?: LeadSource[] | undefined;
    allLeadTypes?: LeadType[] | undefined;
    allTeams?: Team[] | undefined;
    allJobSpecialties?: JobSpecialty[] | undefined;
    allTags?: TagGetDto[] | undefined;
};

export const CompanyContext = createContext<CompanyContextType | null>(null);

export function useCompanyContext() {
    const ctx = useContext(CompanyContext);
    if (!ctx) {
        throw new Error("useCompanyContext must be used within a CompanyProvider");
    }
    return ctx;
}
